export default __webpack_public_path__ + "static/media/InitialPic.2ff9f354.svg";